<template>
  <div class="switch-content">
    <p>{{ label }}</p>
    <div>
      <div class="title">
        <el-tooltip
          v-if="tipText"
          class="item"
          effect="dark"
          :content="tipText"
          placement="left"
        >
          <i class="el-icon-question"></i>
        </el-tooltip>
        <p>{{ value ? activeText : inactiveText }}</p>
      </div>
      <el-switch
        :value="value"
        @change="val => $emit('input', val)"
        active-color="#2154F4"
        inactive-color="#CBCBCB"
      >
      </el-switch>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    activeText: {
      type: String,
      default: ""
    },
    inactiveText: {
      type: String,
      default: ""
    },
    tipText: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="less" scoped>
.switch-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  > p {
    min-width: 72px;
    font-size: 12px;
    color: #999999;
    font-weight: 400;
  }
  > div {
    display: flex;
    align-items: center;
    > .title {
      font-weight: 400;
      font-size: 12px;
      color: #999999;
      line-height: 17px;
      display: flex;
      align-items: center;
      margin-right: 10px;
      > i {
        margin-right: 3px;
        cursor: pointer;
      }
    }
  }
  /deep/ .el-switch {
    height: auto;
    .el-switch__core {
      width: 60px !important;
      height: 28px;
      border-radius: 30px;
      &::after {
        width: 23px;
        height: 23px;
      }
    }
  }
  /deep/ .el-switch.is-checked .el-switch__core::after {
    margin-left: -24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/components/SpSwitch.vue